import React from "react";
import { Button } from "react-bootstrap";
import '../workflow.scss';
import ActionPanel from "../../../../../components/action-panel-modal/action-panel";
import InfoIcon from "../../../../../assets/icons/Icon-Info-Large-75px-Blue.svg";

const SyncModal = ({ workflow, setWorkflowActionModal, acceptAction, header, mainText }) => {

    const onHide = () => {
        setWorkflowActionModal(false);
    };

    const onAccept = () => {
        acceptAction(workflow);
        setWorkflowActionModal(false);
    };

    const text = <div className="workflow-name"><b>{mainText}{workflow.Name}?</b>
        <div className="sync-subtext">This will sync all tasks using this workflow. After syncing, it will update all task workflows to the latest version.</div>
    </div>

    const acceptButton = <Button onClick={() => onAccept()}>Confirm</Button>;

    const rejectButton = (
        <Button className="btn-outlined" onClick={onHide}>
            Cancel
        </Button>
    );

    return (
        <div className="sync-modal">
            <ActionPanel
                show={true}
                onHide={onHide}
                header={header}
                mainText={text}
                icon={InfoIcon}
                acceptButton={rejectButton}
                rejectButton={acceptButton}
            />
        </div>
    )
}

export default SyncModal;